export default {
  contactUsStatus: false,
};
